import React from "react";
import ProductsContainer from "../../search-page/products-container/products-container";
import InfiniteScroll from "react-infinite-scroll-component";
import Grid from "@mui/material/Grid";
import Logo from "../../logo/logo";
import NoResults from "../../no-results/no-results";
import styles from "./search-results-container.module.scss";

type Props = {
  zeviProducts: any[];
  stringBasedProducts: any[];
  zeviSearchPage: any;
  zeviSearchTotalCount: any;
  handleZeviSearchPageChage: Function;
  simpleSearchPage: any;
  simpleSearchTotalCount: any;
  handleSimpleSearchPageChange: Function;
};

const SearchResultsContainer: React.FC<Props> = ({
  zeviProducts = [],
  stringBasedProducts = [],
  zeviSearchPage,
  zeviSearchTotalCount,
  handleZeviSearchPageChage,
  simpleSearchPage,
  simpleSearchTotalCount,
  handleSimpleSearchPageChange,
}) => {
  return (
    <Grid
      container
      columnSpacing={{ xs: 3, sm: 3, md: 6 }}
      p={0}
      sx={{ marginTop: "36px", justifyContent: "center !important" }}
    >
      <Grid item xs={5.6} sm={5.6} md={5.4} lg={5.6}>
        <Logo className={styles.logo} />
        {zeviProducts.length > 0 ? (
          <InfiniteScroll
            dataLength={zeviProducts.length}
            next={() => {
              handleZeviSearchPageChage(zeviSearchPage + 1);
            }}
            hasMore={zeviProducts.length < zeviSearchTotalCount}
            loader={<></>}
            endMessage={<></>}
            pullDownToRefresh={false}
            scrollThreshold="80%"
          >
            <ProductsContainer products={zeviProducts} />
          </InfiniteScroll>
        ) : (
          <NoResults msg="No Products Found" />
        )}
      </Grid>
      <Grid item md={0.1}>
        <hr />
      </Grid>
      <Grid item xs={5.6} sm={5.6} md={5.4} lg={5.6}>
        <h2 className={styles.heading}>String based search</h2>
        {stringBasedProducts.length > 0 ? (
          <InfiniteScroll
            dataLength={stringBasedProducts.length}
            next={() => {
              handleSimpleSearchPageChange(simpleSearchPage + 1);
            }}
            hasMore={stringBasedProducts.length < simpleSearchTotalCount}
            loader={<></>}
            endMessage={<></>}
            pullDownToRefresh={false}
            scrollThreshold="80%"
          >
            <ProductsContainer products={stringBasedProducts} />
          </InfiniteScroll>
        ) : (
          <NoResults msg="No Products Found" />
        )}
      </Grid>
    </Grid>
  );
};

export default SearchResultsContainer;
